import React from 'react'
import { ComplexOwnerResponse } from '../../../api/bridgingFinance/searchComplexOwnersList'
import '../SearchResultsTable.css'

export interface ComplexOwnersListResultsTableProps {
  entries: ComplexOwnerResponse[]
  title: string
  onRowClick?: (row: ComplexOwnerResponse) => void
}

export const ComplexOwnersListResultsTable: React.FC<
  ComplexOwnersListResultsTableProps
> = ({ entries, title, onRowClick }) => {
  const handleClick = (erf: ComplexOwnerResponse) => () => {
    if (onRowClick) onRowClick(erf)
  }

  return (
    <div className="kyc-bf-results-table-container">
      <h3 className="table-title">{title}</h3>
      <table>
        <thead>
          <tr style={{ height: '40px' }}>
            <th style={{ width: '70px' }}>Erf</th>
            <th style={{ width: '70px' }}>Street #</th>
            <th>Street Name</th>
            <th style={{ width: '150px' }}>Address</th>
            <th>Owners Name</th>
            <th style={{ width: '70px' }}>Extent</th>
            <th>Usage</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry, index) => (
            <tr
              key={index}
              onClick={handleClick(entry)}
              style={{ height: '30px' }}
            >
              <td style={{ width: '70px' }}>{entry.erfNo}</td>
              <td style={{ width: '70px' }}>{entry.streetNo || '-'}</td>
              <td>{entry.street}</td>
              <td style={{ width: '150px' }}>{entry.address}</td>
              <td>{entry.owner || '-'}</td>
              <td style={{ width: '70px' }}>{entry.erfExtent}</td>
              <td>{entry.erfUsage}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
